import React from 'react';
import {connect} from 'react-redux';
import Select from 'react-select';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {
    Button,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    TextField,
    withStyles,
    Typography,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
} from 'material-ui';

import {InputFieldCheckbox} from '../../../../components/fields/field_single_checkbox';
import {MaterialUISelect} from '../../../../components/fields/field_material_ui_select';
import {styles, overrideTheme} from '../../style/meta_section';
import classNames from 'classnames';
import {b64toBlob, toDataUrl} from '../../../../components/helpers/helpers';
import {urlRegex} from '../../../../components/helpers/constants';
import {
    PAGE_TYPE_DESTINATION,
    PAGE_TYPE_PRODUCT,
    PAGE_TYPE_PRODUCT_FIXED_DATES,
    PAGE_TYPE_REVIEW,
    PAGE_TYPE_CONTINENT,
    PAGE_TYPE_STAFF_TEAM,
    PAGE_TYPE_BLOG_POST,
    PAGE_TYPE_LANDING,
} from '../../constants';
import DropzoneImageField from '../../../../components/fields/field_dropzone_image';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import ImageDialog from '../image_details_crop';
import MetaSeoFields from '../meta_seo_fields';
import MetaReviewFields from '../meta_review_fields';
import MetaLandingFields from '../meta_landing_fields';
import PageHeadings from '../meta_page_headings';
import ImageEditMetaDialog from '../image_details_meta';
import {
    fetchOverviewAccommodations,
    fetchOverviewDates,
    fetchOverviewRequirements,
    fetchProducts,
    fetchActiveProductsBySiteId,
    fetchSnippetAttributeOptions,
} from '../../meta/thunks';
import {fetchStaffTeams} from '../../../staff/thunks';
import {getLocations} from '../../../locations/thunks';
import {fetchAgeGroups} from '../../../reviews/thunks';
import {fetchLanguages} from '../../../languages/thunks';
import Loader from 'react-loader-advanced';
import {hasError} from '../../actions';

export class PageMetaEdit extends React.Component {
    componentWillMount() {
        if (this.props.open) {
            let siteId = this.props.page.site_id;
            this.props.getLocations(this.props.page.destination_id);
            this.props.fetchOverviewDates(siteId);
            this.props.fetchOverviewAccommodations(siteId);
            this.props.fetchOverviewRequirements(siteId);
            if (this.props.page.type === PAGE_TYPE_REVIEW) {
                this.props.fetchLanguages();
                this.props.fetchAgeGroups();
                this.props.fetchProducts();
            }

            if (this.props.page.type === PAGE_TYPE_LANDING || this.props.page.type === PAGE_TYPE_DESTINATION) {
                this.props.fetchActiveProductsBySiteId(siteId);
            }

            if (this.props.page.type === PAGE_TYPE_STAFF_TEAM) {
                this.props.fetchStaffTeams();
            }

            if (
                this.props.page.type === PAGE_TYPE_PRODUCT ||
                this.props.page.type === PAGE_TYPE_PRODUCT_FIXED_DATES
            ) {
                this.props.fetchSnippetAttributeOptions();
            }
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            errorUrl: false,
            expandedPageHeadings: true,
            expandedMeta: false,
            expandedLocations: false,
            expandedImages: false,
            expandedSnippet: false,
            expandedReviews: false,
            expandedTeams: false,
            expandedLanding: false,
            crop: {
                hero: {
                    openImageMetaPopup: false,
                    cropResult: null,
                    thumbCropResult: null,
                    imageIndex: 0,
                    imageToCrop: null,
                    imageToView: null,
                    openCropPopup: false,
                    imageMeta: {
                        title: '',
                        alt: '',
                        name: '',
                        description: '',
                        link: '',
                    },
                },
            },
        };
    }

    validateField = (value, name) => {
        value.length < 1
            ? this.props.hasError(name, true)
            : this.props.hasError(name, false);
    };

    render() {
        const {
            classes,
            onUpdateHeroImageField,
            heroImage,
            onDeleteHeroImageField,
            onHeroImageMetaUpdate,
            open,
            heroVideoUrl,
            updateHeroVideoUrlField,
            page
        } = this.props;

        const expandedPanelLocations = classNames('expandedPanelLocations', {
            [classes.expandedPanelLocations]:
                this.state.expandedLocations === true,
        });

        let selectedLocations = [];

        if (this.props.selectedLocations) {
            for (let i = 0; i < this.props.selectedLocations.length; i++) {
                selectedLocations.push(this.props.selectedLocations[i].id);
            }
        }

        const hasSnippet =
            page.has_snippet !== undefined &&
            Boolean(page.has_snippet);

        const hasLocations =
            page.type !== undefined &&
            (page.type === PAGE_TYPE_DESTINATION ||
                page.type === PAGE_TYPE_CONTINENT ||
                page.type === PAGE_TYPE_PRODUCT_FIXED_DATES ||
                page.type === PAGE_TYPE_PRODUCT);

        const hasReviews =
            page.type !== undefined &&
            page.type === PAGE_TYPE_REVIEW;

        const hasTeams =
            page.type !== undefined &&
            page.type === PAGE_TYPE_STAFF_TEAM;

        const hasCustomProducts =
            page.type !== undefined &&
            (page.type === PAGE_TYPE_LANDING || page.type === PAGE_TYPE_DESTINATION);

        let teamError = false;
        let teamErrClass = '';
        if (hasTeams) {
            if (
                isNaN(this.props.selectedTeamId) ||
                this.props.selectedTeamId === null ||
                this.props.selectedTeamId === undefined
            ) {
                teamError = true;
                teamErrClass = classNames(classes.hasErrors);
            }
        }

        const hasBlog =
            page.type !== undefined &&
            page.type === PAGE_TYPE_BLOG_POST;

        const hasProductSnippetOrderingAndAttributes =
            page.type !== undefined &&
            (page.type === PAGE_TYPE_PRODUCT_FIXED_DATES ||
                page.type === PAGE_TYPE_PRODUCT);

        const headingErr =
            this.props.breadcrumbTitle === '' || this.props.title === ''
                ? true
                : false;
        const metaTitleErr =
            this.props.metaTitle === null || this.props.metaTitle === ''
                ? true
                : false;
        const metaDescErr =
            this.props.metaDescription === null ||
            this.props.metaDescription === ''
                ? true
                : false;
        const snippetReqErr =
            hasSnippet && this.props.selectedRequirement === '' ? true : false;
        const snippetAccomErr =
            hasSnippet && this.props.selectedAccommodation === ''
                ? true
                : false;
        const snippetDateErr =
            hasSnippet && this.props.selectedDate === '' ? true : false;
        let reviewProductErr =
            hasReviews && !this.props.selectedProducts ? true : false;
        const reviewLangErr =
            hasReviews && this.props.language === undefined ? true : false;
        const reviewAgeErr =
            hasReviews && this.props.ageGroup === undefined ? true : false;
        const reviewQuoteErr =
            hasReviews && this.props.quote === undefined ? true : false;
        const reviewAuthorErr =
            hasReviews && this.props.authorFullName === undefined
                ? true
                : false;
        const blogDateErr =
            hasBlog && this.props.blogDate === undefined ? true : false;
        const blogAuthorErr =
            hasBlog && this.props.blogAuthor === undefined ? true : false;

        const fieldsHaveErrors =
            headingErr ||
            metaTitleErr ||
            metaDescErr ||
            snippetReqErr ||
            snippetAccomErr ||
            snippetDateErr ||
            reviewProductErr ||
            reviewLangErr ||
            reviewAgeErr ||
            reviewQuoteErr ||
            reviewAuthorErr ||
            blogDateErr ||
            blogAuthorErr ||
            teamError;

        if (hasReviews) {
            if (this.props.selectedProducts === undefined) {
                reviewProductErr = true;
            }
            if (
                this.props.selectedProducts !== undefined &&
                this.props.selectedProducts.length < 1
            ) {
                reviewProductErr = true;
            }
        }

        const selectHasError = (selected, name) => {
            let selectError = {};

            if (selected === undefined) {
                selectError = {[name]: true};
            } else {
                if (selected.toString().length < 1) {
                    selectError = {[name]: true};
                }

                if (selected.toString().length > 0) {
                    selectError = {[name]: false};
                }
            }

            return selectError[name];
        };

        let error = false;
        error =
            Object.values(this.props.metaError).find(
                (element) => element === true
            ) !== undefined
                ? true
                : false;

        const headingHasError = classNames(
            (this.props.title === '' || this.props.breadcrumbTitle === '') &&
                classes.hasErrors
        );
        const locationHasError = classNames(
            hasLocations && selectedLocations.length < 1 && classes.hasErrors
        );
        const snippetHasError = classNames(
            hasSnippet &&
                this.props.selectedRequirement === '' &&
                classes.hasErrors,
            hasSnippet &&
                this.props.selectedAccommodation === '' &&
                classes.hasErrors,
            hasSnippet && this.props.selectedDate === '' && classes.hasErrors
        );
        const metaHasError = classNames(
            (this.props.metaTitle === null || this.props.metaTitle === '') &&
                classes.hasErrors,
            (this.props.metaDescription === null ||
                this.props.metaDescription === '') &&
                classes.hasErrors
        );
        const reviewHasError = classNames(
            hasReviews && !this.props.selectedProducts && classes.hasErrors,
            hasReviews && !this.props.language && classes.hasErrors,
            hasReviews && !this.props.ageGroup && classes.hasErrors,
            hasReviews && !this.props.quote && classes.hasErrors,
            hasReviews && !this.props.authorFullName && classes.hasErrors
        );
        const blogHasError = classNames(
            hasBlog && !this.props.blogAuthor && classes.hasErrors,
            hasBlog && !this.props.blogDate && classes.hasErrors
        );
        const productHasError = classNames(
            hasReviews &&
                selectHasError(this.props.selectedProducts, 'products') &&
                classes.hasErrors
        );

        return (
            <div>
                <EditDialog
                    open={open}
                    classes={{
                        paper: classes.paper,
                        fullWidth: classes.fullWidth,
                    }}
                >
                    <Loader
                        show={this.props.loading === true}
                        message={
                            'Please note some information is still loading!'
                        }
                    >
                        <DialogTitle>Edit Meta Section</DialogTitle>
                    </Loader>
                    <DialogContent>
                        <ExpansionPanel
                            style={{marginTop: '15px'}}
                            expanded={this.state.expandedPageHeadings}
                            onChange={(event, expanded) => {
                                this.setState({expandedPageHeadings: expanded});
                            }}
                        >
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography className={headingHasError}>
                                    Headings *
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{display: 'block'}}>
                                <PageHeadings
                                    title={this.props.title}
                                    updateTitleField={
                                        this.props.updateTitleField
                                    }
                                    subheading={this.props.subheading}
                                    updateSubheadingField={
                                        this.props.updateSubheadingField
                                    }
                                    oldUrl={this.props.oldUrl}
                                    updateOldUrlField={
                                        this.props.updateOldUrlField
                                    }
                                    breadcrumbTitle={this.props.breadcrumbTitle}
                                    updateBreadcrumbTitleField={
                                        this.props.updateBreadcrumbTitleField
                                    }
                                    menuTitle={this.props.menuTitle}
                                    updateMenuTitleField={
                                        this.props.updateMenuTitleField
                                    }
                                    validateField={this.validateField}
                                    metaError={this.props.metaError}
                                />
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        {hasLocations && (
                            <MuiThemeProvider theme={overrideTheme}>
                                <ExpansionPanel
                                    className={expandedPanelLocations}
                                    expanded={this.state.expandedLocations}
                                    onChange={(event, expanded) => {
                                        this.setState({
                                            expandedLocations: expanded,
                                        });
                                    }}
                                >
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <Typography
                                            className={locationHasError}
                                        >
                                            Locations *
                                        </Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails
                                        style={{display: 'block'}}
                                    >
                                        <Select
                                            multi={true}
                                            placeholder={
                                                'Type here to search locations...'
                                            }
                                            name="page-locations"
                                            value={selectedLocations}
                                            valueKey={'id'}
                                            labelKey={'city'}
                                            onChange={
                                                this.props.handleLocationsChange
                                            }
                                            options={this.props.locations}
                                            className={
                                                classes.locationsMultiSelect
                                            }
                                        />
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </MuiThemeProvider>
                        )}

                        {hasTeams && (
                            <ExpansionPanel
                                className={'teamHasError'}
                                expanded={this.state.expandedTeams}
                                onChange={(event, expanded) => {
                                    this.setState({expandedTeams: expanded});
                                }}
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography className={teamErrClass}>
                                        Team *
                                    </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails
                                    style={{display: 'block'}}
                                >
                                    <TextField
                                        select
                                        name="team_textfield"
                                        label="Team"
                                        value={
                                            parseInt(
                                                this.props.selectedTeamId,
                                                10
                                            ) || 0
                                        }
                                        fullWidth
                                        onChange={(event) => {
                                            this.props.updatePageMetaTeam(
                                                event.target.value
                                            );
                                        }}
                                        error={false}
                                        helperText={'Please select a team!'}
                                    >
                                        <MenuItem
                                            key={0}
                                            value={0}
                                            disabled
                                            className={classes.selectMenuItem}
                                        >
                                            <span
                                                className={
                                                    classes.selectMenuItemSpan
                                                }
                                            >
                                                Select team here
                                            </span>
                                        </MenuItem>
                                        {this.props.allTeams.map((option) => (
                                            <MenuItem
                                                key={option.id}
                                                value={option.id}
                                                className={
                                                    classes.selectMenuItem
                                                }
                                            >
                                                {option.display_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    {teamError ? (
                                        <Typography
                                            variant="caption"
                                            color="error"
                                        >
                                            Please select a team from the
                                            drop-down!
                                        </Typography>
                                    ) : (
                                        <Typography variant="caption">
                                            Select a team from the drop-down
                                        </Typography>
                                    )}
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        )}

                        {hasBlog && (
                            <ExpansionPanel
                                expanded={this.state.expandedBlog}
                                onChange={(event, expanded) => {
                                    this.setState({expandedBlogMeta: expanded});
                                }}
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography className={blogHasError}>
                                        Blog *
                                    </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails
                                    style={{display: 'block'}}
                                >
                                    <TextField
                                        margin="dense"
                                        id="blogAuthor"
                                        name="blogAuthor"
                                        label="Author Name"
                                        value={this.props.blogAuthor || ''}
                                        onChange={(event) => {
                                            this.props.updatePageMetaBlogAuthor(
                                                event.target.value
                                            );
                                        }}
                                        fullWidth
                                        error={
                                            this.props.metaError[
                                                'blogAuthor'
                                            ] || !this.props.blogAuthor
                                        }
                                        helperText={
                                            this.props.metaError[
                                                'blogAuthor'
                                            ] || !this.props.blogAuthor
                                                ? 'Please fill in the author name!'
                                                : 'Type author name here'
                                        }
                                    />
                                    <TextField
                                        margin="dense"
                                        id="blogDatepicker"
                                        name="blogDate"
                                        label="Date"
                                        type="datetime-local"
                                        value={
                                            this.props.blogDate ||
                                            new Date()
                                                .toISOString()
                                                .substring(0, 16)
                                        }
                                        onChange={(event) => {
                                            this.props.updatePageMetaBlogDate(
                                                event.target.value
                                            );
                                        }}
                                        error={
                                            this.props.metaError['blogDate'] ||
                                            !this.props.blogAuthor
                                        }
                                        helperText={
                                            this.props.metaError['blogDate'] ||
                                            !this.props.blogAuthor
                                                ? 'Please fill in the blog date!'
                                                : 'Type date here'
                                        }
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        )}
                        {hasCustomProducts && (
                            <MuiThemeProvider theme={overrideTheme}>
                                <ExpansionPanel
                                    expanded={this.state.expandedLanding}
                                    onChange={(event, expanded) => {
                                        this.setState({
                                            expandedLanding: expanded,
                                        });
                                    }}
                                >
                                    <ExpansionPanelSummary
                                        expandIcon={<ExpandMoreIcon />}
                                    >
                                        <Typography>Custom Products</Typography>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails
                                        style={{display: 'block'}}
                                    >
                                        <MetaLandingFields
                                            selectedProducts={
                                                this.props
                                                    .landingSelectedProducts
                                            }
                                            allProducts={this.props.products}
                                            updatePageMetaLandingProducts={
                                                this.props
                                                    .updatePageMetaLandingProducts
                                            }
                                        />
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </MuiThemeProvider>
                        )}

                        {hasReviews && (
                            <ExpansionPanel
                                expanded={this.state.expandedReviews}
                                onChange={(event, expanded) => {
                                    this.setState({expandedReviews: expanded});
                                }}
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography className={reviewHasError}>
                                        Review *
                                    </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails
                                    style={{display: 'block'}}
                                >
                                    <MetaReviewFields
                                        languages={this.props.languages}
                                        ageGroups={this.props.ageGroups}
                                        reviewImage={this.props.reviewImage}
                                        classes={classes}
                                        selectedProducts={
                                            this.props.selectedProducts
                                        }
                                        authorFullName={
                                            this.props.authorFullName
                                        }
                                        authorAbbreviatedName={
                                            this.props.authorAbbreviatedName
                                        }
                                        quote={this.props.quote}
                                        imageRatios={
                                            this.props.imageRatiosReview
                                        }
                                        productHasError={productHasError}
                                        selectHasError={selectHasError}
                                        validateField={this.validateField}
                                        metaError={this.props.metaError}
                                        onReviewImageMetaUpdate={
                                            this.props.onReviewImageMetaUpdate
                                        }
                                        language={this.props.language}
                                        ageGroup={this.props.ageGroup}
                                        allProducts={this.props.products}
                                        onCropReviewImage={
                                            this.props.onCropReviewImage
                                        }
                                        onCropReviewThumbImage={
                                            this.props.onCropReviewThumbImage
                                        }
                                        onDeleteReviewImageField={
                                            this.props.onDeleteReviewImageField
                                        }
                                        onUpdateReviewImageField={
                                            this.props.onUpdateReviewImageField
                                        }
                                        updatePageMetaReviewFullName={
                                            this.props
                                                .updatePageMetaReviewFullName
                                        }
                                        updatePageMetaReviewProducts={
                                            this.props
                                                .updatePageMetaReviewProducts
                                        }
                                        updatePageMetaReviewAbbrName={
                                            this.props
                                                .updatePageMetaReviewAbbrName
                                        }
                                        updatePageMetaReviewQuote={
                                            this.props.updatePageMetaReviewQuote
                                        }
                                        updatePageMetaReviewLanguage={
                                            this.props
                                                .updatePageMetaReviewLanguage
                                        }
                                        updatePageMetaReviewAgeGroup={
                                            this.props
                                                .updatePageMetaReviewAgeGroup
                                        }
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        )}

                        <ExpansionPanel
                            expanded={this.state.expandedImages}
                            onChange={(event, expanded) => {
                                this.setState({expandedImages: expanded});
                            }}
                        >
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography className={classes.heading}>
                                    Hero Image
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{display: 'block'}}>
                                <DropzoneImageField
                                    multiple={false}
                                    images={heroImage}
                                    onImageDelete={(image, index) => {
                                        onDeleteHeroImageField(image, index);
                                    }}
                                    onImageClick={(image, index) => {
                                        if (image.new) {
                                            this.updateHeroStateImageToCropAndProcessIt(
                                                image
                                            );
                                        } else {
                                            this.updateHeroStateImageToView(
                                                image
                                            );
                                        }
                                    }}
                                    onImagesDrop={(image) => {
                                        onUpdateHeroImageField(image);
                                    }}
                                />

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="hero_video_url"
                                    label="Hero Video Url"
                                    value={heroVideoUrl || ''}
                                    onChange={(event) => {
                                        updateHeroVideoUrlField(
                                            event.target.value
                                        );

                                        if (
                                            event.target.value.match(urlRegex)
                                        ) {
                                            this.setState({errorUrl: false});
                                        } else {
                                            this.setState({errorUrl: true});
                                        }

                                        if (event.target.value === '') {
                                            this.setState({errorUrl: false});
                                        }
                                    }}
                                    fullWidth
                                    type="url"
                                    error={this.state.errorUrl}
                                    helperText={
                                        this.state.errorUrl
                                            ? 'Please fill in a valid url like: www.google.com, https://google.com, http://google.com!'
                                            : 'Type the video URL here'
                                    }
                                />
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        {hasSnippet && (
                            <ExpansionPanel
                                expanded={this.state.expandedSnippet}
                                onChange={(event, expanded) => {
                                    this.setState({expandedSnippet: expanded});
                                }}
                            >
                                <ExpansionPanelSummary
                                    expandIcon={<ExpandMoreIcon />}
                                >
                                    <Typography
                                        className={
                                            this.props.selectedDate !==
                                                undefined &&
                                            this.props.selectedRequirement !==
                                                undefined &&
                                            this.props.selectedAccommodation !==
                                                undefined
                                                ? snippetHasError
                                                : classes.heading
                                        }
                                    >
                                        {this.props.selectedDate !==
                                            undefined &&
                                        this.props.selectedRequirement !==
                                            undefined &&
                                        this.props.selectedAccommodation !==
                                            undefined
                                            ? 'Snippet *'
                                            : 'Snippet'}
                                    </Typography>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails
                                    style={{display: 'block'}}
                                >
                                    <TextField
                                        multiline
                                        margin="dense"
                                        id="snippet"
                                        label="Snippet Text"
                                        fullWidth
                                        value={
                                            this.props.snippet
                                                ? this.props.snippet
                                                : ''
                                        }
                                        onChange={(event) => {
                                            this.props.updateSnippetField(
                                                event.target.value
                                            );
                                        }}
                                    />
                                    {this.props.selectedDate !== undefined && (
                                        <span
                                            className={
                                                classes.expandedPanelFieldContainer
                                            }
                                        >
                                            <MaterialUISelect
                                                id={'dates-dd-field'}
                                                name={'dates'}
                                                items={this.props.allDates}
                                                selectedItem={
                                                    this.props.selectedDate
                                                }
                                                label={'Dates *'}
                                                onChange={(event) => {
                                                    this.props.updateDatesField(
                                                        event.target.value
                                                    );
                                                    this.validateField(
                                                        event.target.value.toString(),
                                                        event.target.name
                                                    );
                                                }}
                                                className={
                                                    classes.selectMenuItem
                                                }
                                            />
                                            {selectHasError(
                                                this.props.selectedDate,
                                                'dates'
                                            ) ? (
                                                <Typography
                                                    variant="caption"
                                                    color="error"
                                                >
                                                    Please select at least one
                                                    value!
                                                </Typography>
                                            ) : (
                                                <Typography variant="caption">
                                                    Select dates from the
                                                    drop-down
                                                </Typography>
                                            )}
                                        </span>
                                    )}
                                    {this.props.selectedRequirement !==
                                        undefined && (
                                        <span
                                            className={
                                                classes.expandedPanelFieldContainer
                                            }
                                        >
                                            <MaterialUISelect
                                                id={'requirements-dd-field'}
                                                name={'requirements'}
                                                items={
                                                    this.props.allRequirements
                                                }
                                                selectedItem={
                                                    this.props
                                                        .selectedRequirement
                                                }
                                                label={'Requirements *'}
                                                onChange={(event) => {
                                                    this.props.updateRequirementsField(
                                                        event.target.value
                                                    );
                                                    this.validateField(
                                                        event.target.value.toString(),
                                                        event.target.name
                                                    );
                                                }}
                                                className={
                                                    classes.selectMenuItem
                                                }
                                            />
                                            {selectHasError(
                                                this.props.selectedRequirement,
                                                'requirements'
                                            ) ? (
                                                <Typography
                                                    variant="caption"
                                                    color="error"
                                                >
                                                    Please select at least one
                                                    value!
                                                </Typography>
                                            ) : (
                                                <Typography variant="caption">
                                                    Select requirements from the
                                                    drop-down
                                                </Typography>
                                            )}
                                        </span>
                                    )}
                                    {this.props.selectedRequirement !==
                                        undefined &&
                                        this.props.selectedRequirement !==
                                            '' && (
                                            <TextField
                                                multiline
                                                margin="dense"
                                                id="additional_requirements"
                                                label="Additional Requirements Text"
                                                fullWidth
                                                value={
                                                    this.props
                                                        .additional_requirements
                                                }
                                                onChange={(event) => {
                                                    this.props.updateAdditionalRequirementsField(
                                                        event.target.value
                                                    );
                                                }}
                                            />
                                        )}
                                    {this.props.selectedAccommodation !==
                                        undefined && (
                                        <span
                                            className={
                                                classes.expandedPanelFieldContainer
                                            }
                                        >
                                            <MaterialUISelect
                                                id={'accommodation-dd-field'}
                                                items={
                                                    this.props.allAccommodations
                                                }
                                                selectedItem={
                                                    this.props
                                                        .selectedAccommodation
                                                }
                                                name={'accommodation'}
                                                label={'Accommodation *'}
                                                onChange={(event) => {
                                                    this.props.updateAccommodationsField(
                                                        event.target.value
                                                    );
                                                    this.validateField(
                                                        event.target.value.toString(),
                                                        event.target.name
                                                    );
                                                }}
                                                className={
                                                    classes.selectMenuItem
                                                }
                                            />
                                            {selectHasError(
                                                this.props
                                                    .selectedAccommodation,
                                                'accommodation'
                                            ) ? (
                                                <Typography
                                                    variant="caption"
                                                    color="error"
                                                >
                                                    Please select at least one
                                                    value!
                                                </Typography>
                                            ) : (
                                                <Typography variant="caption">
                                                    Select accommodation from
                                                    the drop-down
                                                </Typography>
                                            )}
                                        </span>
                                    )}
                                    {hasProductSnippetOrderingAndAttributes && (
                                        <span
                                            className={
                                                classes.expandedPanelFieldContainer
                                            }
                                        >
                                            <MaterialUISelect
                                                id={'snippet-attribute-field'}
                                                items={
                                                    this.props
                                                        .allSnippetAttributeOptions
                                                }
                                                selectedItem={
                                                    this.props
                                                        .selectedSnippetAttribute
                                                }
                                                name={'snippet-attribute-field'}
                                                label={'Snippet Attribute'}
                                                onChange={(event) => {
                                                    this.props.updateSnippetAttributeField(
                                                        event.target.value
                                                    );
                                                }}
                                                className={
                                                    classes.selectMenuItem
                                                }
                                            />
                                            <Typography variant="caption">
                                                Optionally select a snippet
                                                attribute
                                            </Typography>
                                        </span>
                                    )}

                                    {hasProductSnippetOrderingAndAttributes && (
                                        <span className={classes.expandedPanelFieldContainer}>
                                            <InputFieldCheckbox
                                                checked={Boolean(this.props.isTravelProduct)}
                                                onChange={this.props.updateIsTravelProduct}
                                                name='Travel product'
                                            />
                                            <Typography variant="caption">
                                                Used to specify 'Book Now' button type
                                            </Typography>
                                        </span>
                                    )}

                                    {hasProductSnippetOrderingAndAttributes && (
                                        <span
                                            className={
                                                classes.expandedPanelFieldContainer
                                            }
                                        >
                                            <TextField
                                                margin="dense"
                                                id={'snippet-order-field'}
                                                value={
                                                    this.props.snippetSortOrder
                                                }
                                                name={'snippet-order-field'}
                                                label={'Sort Order'}
                                                type="number"
                                                onChange={(event) => {
                                                    this.props.updateSnippetSortOrderField(
                                                        event.target.value
                                                    );
                                                }}
                                            />
                                            <Typography variant="caption">
                                                Type sort order of snippet
                                                (lower sort order = shown first
                                                on website). Use 0 to revert to
                                                default sort order.
                                            </Typography>
                                        </span>
                                    )}
                                </ExpansionPanelDetails>
                            </ExpansionPanel>
                        )}

                        <ExpansionPanel
                            expanded={this.state.expandedMeta}
                            onChange={(event, expanded) => {
                                this.setState({expandedMeta: expanded});
                            }}
                        >
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <Typography className={metaHasError}>
                                    SEO Meta Information *
                                </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails style={{display: 'block'}}>
                                <MetaSeoFields
                                    metaTitle={this.props.metaTitle}
                                    updateMetaTitleField={
                                        this.props.updateMetaTitleField
                                    }
                                    metaDescription={this.props.metaDescription}
                                    updateMetaDescriptionField={
                                        this.props.updateMetaDescriptionField
                                    }
                                    hasError={(field, metaError) => {
                                        this.props.hasError(field, metaError);
                                    }}
                                    metaError={this.props.metaError}
                                />
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <Typography
                            variant="caption"
                            color="error"
                            style={{marginTop: 10}}
                        >
                            *Mandatory fields
                        </Typography>
                    </DialogContent>
                    <DialogActions className={classes.dialogActionsBtn}>
                        <Button
                            onClick={(ev) => {
                                this.props.handleRequestClose(ev);
                                this.setState({errorUrl: false});
                            }}
                            variant="raised"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={(ev) => this.props.handleRequestDone(ev)}
                            disabled={
                                error || fieldsHaveErrors || this.state.errorUrl
                            }
                            color="primary"
                            variant="raised"
                        >
                            Done
                        </Button>
                    </DialogActions>
                </EditDialog>

                <ImageDialog
                    open={this.state.crop.hero.openCropPopup}
                    cropResult={this.state.crop.hero.cropResult}
                    thumbCropResult={this.state.crop.hero.thumbCropResult}
                    imageToCrop={this.state.crop.hero.imageToCrop}
                    imageRatios={this.props.imageRatiosHero}
                    imageMeta={this.state.crop.hero.imageMeta}
                    setAltField={(alt) => this.setStateHeroAltField(alt)}
                    setTitleField={(title) =>
                        this.setStateHeroTitleField(title)
                    }
                    setDescriptionField={(description) =>
                        this.setStateHeroDescriptionField(description)
                    }
                    setLinkField={(link) => this.setLinkField(link)}
                    setNameField={(name) => this.setStateHeroNameField(name)}
                    setCropResult={(cropResult) =>
                        this.updateHeroStateCropResult(cropResult)
                    }
                    setThumbCropResult={(thumbCropResult) =>
                        this.updateHeroStateCropThumbResult(thumbCropResult)
                    }
                    handleSubmit={() => this.submitHeroCropResult()}
                    handleClose={() => {
                        this.clearHeroCropStateAfterPopupClose();
                    }}
                    clearCroppedResult={() => {
                        this.clearCroppedResult();
                    }}
                    isHero={true}
                    displayAllRatios={false}
                />

                <ImageEditMetaDialog
                    open={this.state.crop.hero.openImageMetaPopup}
                    classes={classes}
                    imageMeta={this.state.crop.hero.imageMeta}
                    image={this.state.crop.hero.imageToView}
                    setAltField={(alt) => this.setStateHeroAltField(alt)}
                    setTitleField={(title) =>
                        this.setStateHeroTitleField(title)
                    }
                    setDescriptionField={(description) =>
                        this.setStateHeroDescriptionField(description)
                    }
                    setLinkField={(link) => this.setLinkField(link)}
                    setNameField={(name) => this.setStateHeroNameField(name)}
                    handleSubmit={() => {
                        onHeroImageMetaUpdate(this.state.crop.hero.imageMeta);
                        this.clearHeroCropStateAfterPopupClose();
                    }}
                    handleCancel={() => {
                        this.clearHeroCropStateAfterPopupClose();
                    }}
                />
            </div>
        );
    }

    clearCroppedResult() {
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    cropResult: null,
                },
            },
        });
    }

    clearHeroCropStateAfterPopupClose() {
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    cropResult: null,
                    thumbCropResult: null,
                    openImageMetaPopup: false,
                    imageToCrop: null,
                    openCropPopup: false,
                    imageMeta: {
                        title: '',
                        alt: '',
                        name: '',
                        description: '',
                        link: '',
                    },
                },
            },
        });
    }

    clearHeroCropStateAfterPopupSubmit() {
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    openImageMetaPopup: false,
                    imageToCrop: null,
                    openCropPopup: false,
                    imageMeta: {
                        title: '',
                        alt: '',
                        name: '',
                        description: '',
                        link: '',
                    },
                },
            },
        });
    }

    updateHeroStateCropResult(cropResult) {
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    cropResult,
                },
            },
        });
    }

    updateHeroStateCropThumbResult(thumbCropResult) {
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    thumbCropResult,
                },
            },
        });
    }

    updateHeroStateImageToView(image) {
        const {title, alt, name, description, link} = image;
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    openCropPopup: false,
                    openImageMetaPopup: true,
                    imageToCrop: null,
                    imageToView: image,
                    imageMeta: {
                        title,
                        alt,
                        name,
                        description,
                        link,
                    },
                },
            },
        });
    }

    updateHeroStateImageToCrop(image) {
        const {title, alt, name, description, link} = image;
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    imageToCrop: image,
                    openCropPopup: true,
                    imageMeta: {
                        title,
                        alt,
                        name,
                        description,
                        link,
                    },
                },
            },
        });
    }

    setStateHeroAltField(alt) {
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    imageMeta: {
                        ...this.state.crop.hero.imageMeta,
                        alt,
                    },
                },
            },
        });
    }

    setStateHeroTitleField(title) {
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    imageMeta: {
                        ...this.state.crop.hero.imageMeta,
                        title,
                    },
                },
            },
        });
    }

    setStateHeroDescriptionField(description) {
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    imageMeta: {
                        ...this.state.crop.hero.imageMeta,
                        description,
                    },
                },
            },
        });
    }

    setLinkField(link) {
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    imageMeta: {
                        ...this.state.crop.hero.imageMeta,
                        link,
                    },
                },
            },
        });
    }

    setStateHeroNameField(name) {
        this.setState({
            ...this.state,
            crop: {
                hero: {
                    ...this.state.crop.hero,
                    imageMeta: {
                        ...this.state.crop.hero.imageMeta,
                        name,
                    },
                },
            },
        });
    }

    updateHeroStateImageToCropAndProcessIt(image) {
        this.updateHeroStateImageToCrop(image);
        let croppedImage = this.props.heroImage.croppedImage;
        if (croppedImage) {
            toDataUrl(croppedImage, (cropResult) => {
                this.updateHeroStateCropResult(cropResult);
            });
        }
        let croppedImageThumb = this.props.heroImage.croppedImageThumb;
        if (croppedImageThumb) {
            toDataUrl(croppedImageThumb, (cropResult) => {
                this.updateHeroStateCropThumbResult(cropResult);
            });
        }
    }

    submitHeroCropResult() {
        if (this.state.crop.hero.cropResult) {
            let imageObject = b64toBlob(this.state.crop.hero.cropResult);
            const imageUrlBlob = URL.createObjectURL(imageObject);
            this.props.onCropImage(
                imageObject,
                imageUrlBlob,
                imageObject,
                this.state.crop.hero.imageIndex
            );
        }
        if (this.state.crop.hero.thumbCropResult) {
            let thumbImageObject = b64toBlob(
                this.state.crop.hero.thumbCropResult
            );
            const imageThumbUrlBlob = URL.createObjectURL(thumbImageObject);
            this.props.onCropThumbImage(
                thumbImageObject,
                imageThumbUrlBlob,
                thumbImageObject,
                this.state.crop.hero.imageIndex
            );
        }
        this.props.onHeroImageMetaUpdate(
            this.state.crop.hero.imageMeta,
            this.state.crop.hero.imageIndex
        );
        this.clearHeroCropStateAfterPopupSubmit();
    }
}

const mapStateToProps = (state, props) => ({
    blogDate: state.pageBuilderMetaPopup.data.blog.date,
    blogAuthor: state.pageBuilderMetaPopup.data.blog.author,
    selectedLocations: state.pageBuilderMetaPopup.data.locations,
    selectedTeamId: state.pageBuilderMetaPopup.data.team_id,
    locations: state.locations.all,
    languages: state.languages.all,
    ageGroups: state.reviews.allAgeGroups,
    allTeams: state.staff.allTeams,
    allDates: state.pageBuilderMetaPopup.overviewAll.allDates,
    allAccommodations: state.pageBuilderMetaPopup.overviewAll.allAccommodations,
    allRequirements: state.pageBuilderMetaPopup.overviewAll.allRequirements,
    allSnippetAttributeOptions:
        state.pageBuilderMetaPopup.allSnippetAttributeOptions,
    additional_requirements:
        state.pageBuilderMetaPopup.data.product.additional_requirements,
    selectedDate: state.pageBuilderMetaPopup.data.product.dates_label_id,
    selectedRequirement:
        state.pageBuilderMetaPopup.data.product.requirements_label_id,
    selectedAccommodation:
        state.pageBuilderMetaPopup.data.product.accommodation_label_id,
    snippetSortOrder:
        state.pageBuilderMetaPopup.data.product.snippet_sort_order,
    selectedSnippetAttribute:
        state.pageBuilderMetaPopup.data.product.snippet_attribute,
    isTravelProduct:
        state.pageBuilderMetaPopup.data.product.is_travel_product,
    products: state.pageBuilderMetaPopup.allProducts,
    selectedProducts: state.pageBuilderMetaPopup.data.review.products,
    landingSelectedProducts: state.pageBuilderMetaPopup.data.custom.products,
    metaError: state.pageBuilder.metaSectionPopup.error,
});

export default connect(mapStateToProps, {
    getLocations: getLocations,
    fetchLanguages: fetchLanguages,
    fetchAgeGroups: fetchAgeGroups,
    fetchStaffTeams: fetchStaffTeams,
    fetchOverviewDates: fetchOverviewDates,
    fetchOverviewAccommodations: fetchOverviewAccommodations,
    fetchOverviewRequirements: fetchOverviewRequirements,
    fetchProducts: fetchProducts,
    fetchActiveProductsBySiteId: fetchActiveProductsBySiteId,
    fetchSnippetAttributeOptions: fetchSnippetAttributeOptions,
    hasError: hasError,
})(withStyles(styles)(PageMetaEdit));



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/meta_section_edit.js